// extracted by mini-css-extract-plugin
module.exports = {"inPlayerOverlay":"_2V4brvXzoK8sj1qB05reE1"};